import CacheEnabledApiClient from './CacheEnabledApiClient';

// AIVIO canned (upstream 2ed68cf20): canned responses are cached in IndexedDB and
// filtered in the browser, so the "/" picker sends no per-keystroke search requests.
class CannedResponse extends CacheEnabledApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'canned_response';
  }

  // The index endpoint returns a bare array instead of a payload wrapper
  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  // AIVIO: a backend without the canned_response cache key (initializer
  // zz_aivio_canned_cache_keys.rb not mounted) returns no key at all. Comparing
  // undefined with undefined would pin a stale local copy forever, so treat a
  // missing key as "cache invalid" and fall back to one network read per open.
  async validateCacheKey(cacheKeyFromApi) {
    if (!cacheKeyFromApi) return false;
    return super.validateCacheKey(cacheKeyFromApi);
  }
}

export default new CannedResponse();
